<template>
  <div class="sliders" :interval="3000">
    <div :class="{ 'my-progress': true, 'progress-show': pro_show}">
      <el-progress type="circle" :percentage="cur_per" class="progress-circle"></el-progress>
    </div>
    <el-image :src="campus_header" style=" width: 100%; margin-bottom: 3%"></el-image>
    <el-image :src="campus_title" style=" width: 100%; margin-bottom: 3%"></el-image>
    <div class="campus-item">
      <el-image :src="campus_welfare" class="campus-img"></el-image>
    </div>
    <el-dialog title="基本信息" :visible.sync="dialogFormVisible">
      <el-form label-position="right" label-width="80px" :model="form" :rules="rules">
        <div class="dialog-upload-form">
          <el-form-item label="姓名:" prop="name">
            <el-input v-model="form.name" style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="telephone">
            <el-input v-model="form.telephone" style="width: 80%;"></el-input>
          </el-form-item>
          <el-form-item label="校招/社招">
            <el-select v-model="form.job_type" placeholder="招聘类型">
              <el-option label="校招" value="校园招聘"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应聘岗位"  prop="job_name">
            <el-select v-model="form.job_name" placeholder="岗位名称">
              <el-option v-for="job in job_name" :label="job.name" :value="job.value" :key='job.value'></el-option>
            </el-select>
          </el-form-item>
          <div style="width:  80%;margin: auto;">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="https://bolegames.com/api/upload_emails"
              :on-preview="handlePreview"
              :on-exceed="handleExceed"
              :data="form"
              :on-success="fileUploadSuccess"
              :on-error="fileUploadFail"
              :before-upload="beforeAvatarUpload"
            >
              <el-button size="small" type="primary">选取简历并投递</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/word/pdf文件，且不超过10M</div>
            </el-upload>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="job">
      <div class="demo-image">
        <div class="block job-intro">
          <div style="
              color: #ffffff;
              z-index: 1000;
              top:0;
              left: 0;
              right: 0;
              margin:auto;
              width: 90%;
              padding: 0;
              height: 100%;">
            <p class="p-title">{{job_info.job_title}}</p>
            <p class="p-name">{{job_info.job_name}}</p>
            <div v-for="details_item in job_info.job_details">
              <p class="p-content">{{details_item}}</p>
            </div>

            <p class="p-name">{{job_info.job_need_name}}</p>
            <div v-for="need_item in job_info.job_need">
              <p class="p-content">{{need_item}}</p>
            </div>

            <div class="upload-btn">
              <el-image :src="upload_file" @click="changeStatus"></el-image>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  JPG/PNG/Word/PDF-->
</template>

<script>
  export default {
    props: ['isHome'], // 如果是主页的navbar，则添加透明滚动渐变效果
    data() {
      return {
        campus_header: `${require('../assets/resource_10_23/zhaopin_header.jpg')}`,
        campus_title: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_title.png',
        campus_welfare: `${require('../assets/resource_10_23/fuli_1.png')}`,
        campus_up: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/campus_up.png',
        upload_file: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images_bole/download_file_btn.png',
        job_info: {},
        isShowDialog: true,
        dialogTableVisible: false,
        dialogFormVisible: false,
        formLabelAlign: 'right',
        upload_file_success: false,
        form: {
          name: '',
          job_name: '',
          job_type: '校园招聘',
          telephone: '',
        },
        formLabelWidth: '80px',
        fileList: [],
        rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          telephone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { min: 11, max: 11, message: '请输入11位手机号', trigger: 'blur' },
          ],
          job_name: [
            { required: true, message: '请选择投递的岗位', trigger: 'blur' },
          ],
        },
        job_name: [],
        cur_per: 0,
        pro_show: true
      };
    },
    created() {
      this.getJson();
    },
    methods: {
      getJson() {
        const json = require('../assets/json/new_campus_job.json');
        const job_name = window.location.href.split('job_name=')[1];
        this.job_info = json[job_name ? job_name : 'video_designer'];
        this.job_name = Object.keys(json).map((item) => {
          return {
            name: json[item].job_title,
            value: json[item].job_title,
          };
        })
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      handlePreview(file) {
        // console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      fileUploadSuccess() {
        this.fileList = [];
        setTimeout(() => {
          this.cur_per = 100;
          this.dialogFormVisible = false;
          this.upload_file_success = true;
          setTimeout(() => {
            alert('简历投递成功!');
            this.pro_show = true;
            this.cur_per = 0;
          }, 700);
        }, 300);
      },
      fileUploadFail() {
        // console.log('文件上传失败');
      },
      beforeAvatarUpload(file) {
        if (!this.form.job_name) {
          alert('请选择投递的岗位!');
          return false;
        }
        if (!this.form.name) {
          alert('请填写 姓名!');
          return false;
        }
        if (!this.form.telephone) {
          alert('请填写手机号!');
          return false;
        }

        const FileExt = file.name.replace(/.+\./, '');
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (['jpg', 'jpeg', 'png', 'txt', 'pdf', 'doc', 'docx'].indexOf(FileExt.toLowerCase()) === -1) {
          alert('请上传后缀名为jpg、jpeg、png、txt、pdf、doc、docx');
          return false;
        } else if (!isLt2M) {
          alert('上传文件大小不能超过 10MB!');
          return false;
        } else {
          this.pro_show = false;
          var timer = setInterval(() => {
            if (this.cur_per < 100) {
              this.cur_per += Math.ceil(Math.random()*10);
            }
            // console.log(this.cur_per)
            if (this.cur_per >=60) {
              clearInterval(timer);
            }
          }, 300);
          return true;
        }
      },
      changeStatus() {
        this.dialogFormVisible = true;
        if (this.upload_file_success) {
          this.$refs.upload.clearFiles();
        }
      },
    },
  };
</script>


<style lang="less" scoped>
  .progress-show {
    display: none;
  }
  .my-progress {
    background: rgba(0, 0, 0, 0.9);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 3000;
    .progress-circle {
      top: 40%;
    }
  }
  .navbar-solid {
    padding: 30px;
  }

  .src_banner {
    margin-top: -10px;
    width: 100%
  }

  .job {
    margin-bottom: 20px;
  }

  .demo-image {

    background-repeat: no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100%;
    margin-top: 11%;

    .game_img {
      margin-left: auto;
      margin-right: auto;
      display: block;
      width: 53%;
    }

    /*height: 2000px;*/
  }

  .sliders {
    overflow: hidden;
    background-image: url("https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/all_bg.jpg");

    .content {
      z-index: 5;
      color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      h1 {
        font-size: 120px;
        font-weight: 800;
        margin: 0px;
        text-align: center;
      }

      h2 {
        font-size: 60px;
        font-weight: 600;
        margin: 0px;
        text-align: center;

      }
    }

    .el-carousel__item {
      /* Center and scale the image nicely */
      /* 优雅的图片居中自适应方案 */
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      overflow: hidden;

    }
  }

  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .fade-right-enter-active {
    transition: all .5s ease;
  }

  .fade-right-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .fade-right-enter, .fade-right-leave-to
    /* .fade-right-leave-active for below version 2.1.8 */ {
    transform: translateX(40px);
    opacity: 0;
  }

  .fade-left-enter-active {
    transition: all .5s ease;
  }

  .fade-left-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .fade-left-enter, .fade-left-leave-to
    /* .fade-left-leave-active for below version 2.1.8 */ {
    transform: translateX(-40px);
    opacity: 0;
  }

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
</style>



// WEBPACK FOOTER //
// src/views/CampusJobDetails.vue